import "core-js/stable";
// import "regenerator-runtime/runtime";

import 'amfe-flexible'

import Vue from 'vue'

import '@/plugins'

import { Toast } from 'vant';
Toast.setDefaultOptions('loading', {
    forbidClick: true,
    overlay: false,
    duration: 0,
    position: 'middle'
});
import '@/assets/styles/index.scss'
import App from './App.vue'
import router from './router'
import '@/utils/appCallWeb';
import '@/utils/permission'

import i18n from '@/locale'

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
